import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          Browse Product Categories
        </h2>
        <p className="text-foreground-600 mb-8 max-w-xl mx-auto">
          Select a category below to explore premium products on our main store. Each category features curated selections for your shopping needs.
        </p>

        <div ref={dropdownRef} className="relative inline-block w-full max-w-md">
          <button
            onClick={() => setOpen(!open)}
            className="w-full flex items-center justify-between px-5 py-3.5 bg-background-100 border border-background-200/70 rounded-xl text-foreground-800 text-sm font-medium hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <i className="ri-menu-line text-lg"></i>
              <span>Choose a Category</span>
            </span>
            <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-lg transition-transform duration-200`}></i>
          </button>

          {open && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-xl shadow-lg overflow-hidden z-40 animate-fadeIn">
              <div className="max-h-72 overflow-y-auto py-1">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 cursor-pointer"
                  >
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className={`${cat.icon} text-base`}></i>
                    </span>
                    <span>{cat.name}</span>
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}